import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Request } from '../classes/request';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class RequestService {
    API_REQUEST_URL = config.serverAddress + ':' + config.serverPort + '/request/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get<Array<Request>>(this.API_REQUEST_URL + 'all');
    }
    getByToken(token: string | null) {
        return this.http.get<Request>(this.API_REQUEST_URL + 'token/' + token);
    }
    getByVATNumber(vatNumber: string | null) {
        return this.http.get<Array<Request>>(this.API_REQUEST_URL + 'vat/' + vatNumber);
    }
    getByIDCustomer(id: string | null) {
        return this.http.get<Array<Request>>(this.API_REQUEST_URL + 'customer/' + id);
    }
    getByID(id: string | null) {
        return this.http.get<Request>(this.API_REQUEST_URL + id);
    }
    create(request: Request) {
        return this.http.post<Request>(this.API_REQUEST_URL + 'create', request);
    }
    update(request: Request) {
        return this.http.put<Request>(this.API_REQUEST_URL + 'update', request);
    }
    delete(id: number | undefined) {
        return this.http.delete(this.API_REQUEST_URL + 'delete/' + id);
    }
}
